import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/(sub-layout)/remote-monitoring-control/@section2/page.tsx");
